import * as React from 'react';
import { ITheme } from '@uifabric/styling';
import { classNamesFunction } from '@uifabric/utilities';
import { getExtendedTheme } from 'owa-fabric-theme';
import { getStyles } from './RecipientWellLabelWithContactPicker.styles';
import { RecipientType } from 'owa-recipient-common/lib/store/schema/RecipientType';
import getRecipientString from 'owa-readwrite-recipient-well/lib/utils/getRecipientString';
import {
    RecipientWellLabelWithContactPickerStyleProps,
    RecipientWellLabelWithContactPickerStyles,
} from './RecipientWellLabelWithContactPicker.types';

const getClassNames = classNamesFunction<
    RecipientWellLabelWithContactPickerStyleProps,
    RecipientWellLabelWithContactPickerStyles
>();

interface RecipientWellLabelProps {
    onClick?: () => void;
    recipientType: RecipientType;
    theme?: ITheme;
}

export const RecipientWellLabel = React.forwardRef(
    (
        { onClick, recipientType, theme = getExtendedTheme() }: RecipientWellLabelProps,
        ref: React.Ref<HTMLDivElement>
    ) => {
        const classNames = getClassNames(getStyles, {
            theme: theme,
            isClickable: onClick !== undefined,
        });
        return recipientType != RecipientType.None ? (
            <div
                ref={ref}
                data-is-focusable={true}
                tabIndex={0}
                onClick={onClick}
                className={classNames.label}>
                {getRecipientString(recipientType)}
            </div>
        ) : null;
    }
);
